import type { TableColumn } from '../types/Table.type'

export function createSkeletonCell(): HTMLTableCellElement {
  const td = document.createElement('td')
  td.part = 'cell'

  const skeleton = document.createElement('wa-skeleton')
  skeleton.setAttribute('effect', 'sheen')

  td.appendChild(skeleton)

  return td
}

export function createSkeletonRow(columns: TableColumn[]): HTMLTableRowElement {
  const tr = document.createElement('tr')
  tr.part = 'row skeleton-row'

  for (let i = 0; i < columns.length; i++) {
    tr.appendChild(createSkeletonCell())
  }

  return tr
}

export function createSkeletonRows(columns: TableColumn[], rowCount: number): DocumentFragment {
  const fragment = document.createDocumentFragment()

  for (let i = 0; i < rowCount; i++) {
    fragment.appendChild(createSkeletonRow(columns))
  }

  return fragment
}
